import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
    name: 'genericfilter',
    pure: false
})
export class GenericFilterPipe implements PipeTransform {
    transform(items: any[], filter: string, filterObj:string): any {
        if (!items || !filter) {
            return items;
        }
   
        return items.filter(item => item[filterObj].toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    }
}